import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import createMutationsSharer from "vuex-shared-mutations";

// state
import Snackbar from '@/components/custom-components/snackbar/snackbar.state'
import auth from './modules/auth/index'
import permissions from './modules/Permissions/index'
import locations from './modules/Locations/index'
import locationGroups from './modules/LocationGroups/index'
import clover from './modules/Clover/index'
import cloverGr8 from './modules/Clover/gr8'

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [
    createPersistedState(),
    createMutationsSharer({
      predicate: [
        'clover/detailsMutate',
        'cloverGr8/detailsMutate',
      ]
    }),
  ],
  modules: { Snackbar, auth, permissions, locations, locationGroups, clover, cloverGr8 }
})

export default store
